<script lang="ts" setup>
import { useLeaderboardPodiumData } from '#leaderboards/composables/useLeaderboardPodiumData'

const { performance, isLoading } = useLeaderboardPodiumData()

const tickerItems = computed(() =>
  (performance.value ?? []).map((mm, index) => ({
    rank: index + 1,
    name: mm.marketMakerName,
    imageUrl: mm.marketMakerImageUrl,
  })),
)
</script>

<template>
  <PrMmRankingsTicker :items="tickerItems" :loading="isLoading" />
</template>
